<div style="overflow-y: auto; height: calc(100vh - 176px);">
  <div class="container-fluid">
    <form [formGroup]="userForm" (ngSubmit)="save()">
      <div class="row justify-content-center pt-4">
        <div class="col-12 col-md-11">
          <span class="rm-title rm-title-3">Deal Metrics</span><br/>
          <span class="rm-title rm-title-6 rm-lighter">This is where you can edit the metrics of the deal.</span>
        </div>
      </div>
      <div class="row justify-content-center pt-4">
        <div class="col-12 col-md-11">
          <div class="row">
            <span style="font-size: large; font-weight: bold;">Issuer Overview</span>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline" [style.padding-top]="0">
                <mat-label style="font-size: medium;">Entity Name</mat-label>
                <input class="form-input" matInput formControlName="issuerEntityName" required="true"
                       placeholder="Rondeivu"/>
                <mat-error *ngIf="userForm.get('issuerEntityName')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Country</mat-label>
                <mat-select id="country" formControlName="countryId" required="true" placeholder="Canada">
                  <mat-option *ngFor="let c of lookupService.lookups.countries" [value]="c.key">{{c.value}}</mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.get('countryId')?.hasError('required')">Please choose one.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!--              state-->
              <div *ngIf="(userForm.get('countryId')?.value =='US') || (userForm.get('countryId')?.value == '')">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label style="font-size: medium;">State</mat-label>
                  <mat-select id="state" [required]="userForm.get('countryId')?.value =='US'" formControlName="stateorProvinceId" placeholder="Alaska">
                    <mat-option *ngFor="let s of lookupService.lookups.stateTypes" [value]="s.key"> {{s.value}} </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userForm.get('stateorProvinceId')?.hasError('required')">Please choose one.</mat-error>
                </mat-form-field>
              </div>

              <!--              province-->
              <div *ngIf="userForm.get('countryId')?.value === 'CA'">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label style="font-size: medium;">Province</mat-label>
                  <mat-select id="province"
                              [required]="userForm.get('countryId')?.value === 'CA'"
                              formControlName="stateorProvinceId">
                    <mat-option *ngFor="let p of lookupService.lookups.provinceTypes" [value]="p.key">
                      {{p.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userForm.get('stateorProvinceId')?.hasError('required')">Please choose one.</mat-error>
                </mat-form-field>
              </div>

            </div>
            <div class="col-12 col-md-6">
              <!-- City -->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">City</mat-label>
                <input class="form-input" matInput placeholder="i.e. Toronto" formControlName="city" [required]="true"/>
                <mat-error *ngIf="userForm.get('city')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <!--        HEADER-->
          <br/>
          <!--          row start-->
          <div class="row pt-2">
            <span style="font-size: large; font-weight: bold;">Deal Overview</span>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!--              deal type-->
              <div class="radio-group" formArrayName="issuerDeals">
                <b><mat-label>Deal Type<sup>*</sup></mat-label></b>
                <div *ngFor="let dealType of dealTypes.controls; index as i;">
                  <mat-checkbox color="primary" [formControlName]="i">{{ lookupService.lookups.dealTypes[i].value }}</mat-checkbox>
                </div>
                <mat-error *ngIf="userForm.get('issuerDeals')?.hasError('minChecked')">At least one checkbox must be checked</mat-error>
              </div>
            </div>

            <div class="col-12 d-flex d-md-none">
              &nbsp;
            </div>

            <div class="col-12 col-md-6">
              <div class="radio-group" formArrayName="issuerDealAssets">
                <b><mat-label>Asset Class<sup>*</sup></mat-label></b>
                <div *ngFor="let asset of assetClasses.controls; index as i;">
                  <mat-checkbox color="primary" [formControlName]="i">{{ lookupService.lookups.assetTypes[i].value }} </mat-checkbox>
                </div>
                <mat-error *ngIf="userForm.get('issuerDealAssets')?.hasError('minChecked')">At least one checkbox must be checked</mat-error>
              </div>
            </div>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12">
              <mat-label style="font-size: medium;">Keywords</mat-label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-chip-list #chipList aria-label="Theme selection">
                  <mat-chip
                    *ngFor="let st of selectedThemes"
                    (removed)="removeWord(st)">
                    {{st}}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input
                    [placeholder]="selectedThemes.length==0? 'i.e. sustainable, litigationfinance, cashflowpositive': ''"
                    #themeInput
                    [formControl]="themeCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addWord($event)"/>
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTheme($event)">
                  <mat-option *ngFor="let ft of lookupService.lookups.areasOfFocus" [value]="ft.key">
                    {{ft.value}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <!--        HEADER-->
          <br/>
          <!--          row start-->
          <div class="row pt-4">
            <span style="font-size: large; font-weight: bold;">Size and Timing</span>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!--             total fund size-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Total Fund Size (Million USD)</mat-label>
                <input type="number" matInput id="totSz" formControlName="fundraiseSize" [required]="true"
                       placeholder="50"/>
                <mat-error *ngIf="userForm.get('fundraiseSize')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <!--              timeline-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Timeline to Close</mat-label>
                <mat-select id="tltc" formControlName="timeLineTypeId" [required]="true" placeholder="1-4 weeks">
                  <mat-option *ngFor="let tl of lookupService.lookups.timeLineTypes" [value]="tl.key">
                    {{tl.value}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.get('timeLineTypeId')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!--              capacity to raise-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Capacity to Raise on Rondeivu (Million USD)</mat-label>
                <input type="number" matInput formControlName="rondeivuFundraiseSize" [required]="true"
                       placeholder="20"/>
                <mat-error *ngIf="userForm.get('rondeivuFundraiseSize')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <!-- has deal closed-->
              <mat-label style="font-size: medium;">Has first close occurred?</mat-label>
              <br/>
              <mat-radio-group formControlName="firstCloseOccured">
                <mat-radio-button *ngFor="let obj of [{key:'Yes',value:true},{key:'No',value:false}]" color="primary"
                                  [value]="obj.value">
                  {{obj.key}}&nbsp;
                </mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="userForm.get('firstCloseOccured')?.hasError('required')">This field is required.</mat-error>
            </div>
            <div class="col-12 col-md-3">
              <!--  anchor seeking-->
              <mat-label style="font-size: medium;">Are you seeking an anchor/lead?</mat-label>
              <br/>
              <mat-radio-group formControlName="anchorSeeking">
                <mat-radio-button *ngFor="let obj of [{key:'Yes',value:true},{key:'No',value:false}]" color="primary"
                                  [value]="obj.value">
                  {{obj.key}}&nbsp;
                </mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="userForm.get('anchorSeeking')?.hasError('required')">This field is required.</mat-error>
            </div>
          </div>
          <!--        HEADER-->
          <br/>
          <div class="row pt-4">
            <span style="font-size: large; font-weight: bold;">Target and Return</span>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!-- return bear case-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Target Return - Bear Case (MOIC Multiple)</mat-label>
                <input type="number" matInput formControlName="targetMoicBear" [required]="true"
                       placeholder="50">
                <mat-error *ngIf="userForm.get('targetMoicBear')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <!--min duration-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Investment Timeline - Minimum Duration (years)</mat-label>
                <input type="number" matInput formControlName="minimumDuration" required
                       placeholder="10">
                <mat-error *ngIf="userForm.get('minimumDuration')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <!-- row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!-- base case-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Target Return - Base Case (MOIC Multiple)</mat-label>
                <input type="number" matInput formControlName="targetMoicBase" required
                       placeholder="20">
                <mat-error *ngIf="userForm.get('targetMoicBase')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <!--              expected duration-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Investment Timeline - Expected Duration (years)</mat-label>
                <input type="number" matInput formControlName="expectedDuration" required
                       placeholder="25">
                <mat-error *ngIf="userForm.get('expectedDuration')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <!--              best case-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Target Return - Best Case (MOIC Multiple)</mat-label>
                <input type="number" matInput formControlName="targetMoicBest" required
                       placeholder="110">
                <mat-error *ngIf="userForm.get('targetMoicBest')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <!--max duration-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Investment Timeline - Maximum Duration (years)</mat-label>
                <input type="number" matInput formControlName="maximumDuration" required
                       placeholder="30">
                <mat-error *ngIf="userForm.get('maximumDuration')?.hasError('required')">This field is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <br/>
          <div class="row pt-4">
            <span style="font-size: large; font-weight: bold;">Additional Notes</span>
          </div>
          <br/>
          <br/>
          <!-- row start-->
          <div class="row">
            <div class="col-12">
              <!--notes-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label style="font-size: medium;">Private Notes</mat-label>
                <textarea matInput placeholder="Type more notes on the deal here..." formControlName="notes"></textarea>
              </mat-form-field>
            </div>
          </div>
          <!-- BUTTONS-->
          <div class="row pt-5">
            <div class="col-12 text-end">
              <button mat-raised-button
                color="primary"
                type="submit"
                [hasPermission]="util.Permission.CAN_EDIT_DEAL_METRICS"
                [disabledOption1]="{ condition: userForm.invalid, message: 'Form not valid' }"
              >Save Deal Metric Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <br/>
    </form>
  </div>
</div>

